import makeStyles from "@mui/styles/makeStyles";
import { View } from "../../Base";

const useStyles = makeStyles({
  container: {
    margin: "20px 0px 0px 20px",
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },
});

export const RemoveDriverContent = ({ driver }) => {
  const styles = useStyles();
  return (
    <View className={styles.container}>
      {`Are you sure you want to remove ${driver.driverCode.split("*")[1]} ${
        driver.driverName
      } profile completely?`}
    </View>
  );
};
